import React, {Component} from 'react';
import {connect} from "react-redux";

import {Hidden} from '@material-ui/core';

import NewNote from "./components/newNote";
import StationInfo from "./components/stationInfo";
import CheckIn from "../components/checkIn";

import './styles.scss';
import _ from "lodash";



class StationDetail extends Component {

    getSelectedStation = () =>{
        return _.find(this.props.stations.list, (station)=>{
            return station.id === this.props.stations.selectedStation
        });
    };

    render() {
        return (
            <div>
                <Hidden xsDown>
                    <CheckIn />
                </Hidden>
                {!this.props.notes_actions.showNewNote &&
                <StationInfo station={this.getSelectedStation()} />
                }
                {this.props.notes_actions.showNewNote && <NewNote/>}
            </div>
        );
    }
}


const mapStateToProps = (state) => {
    return {
        user: state.user,
        visits: state.visits,
        notes_actions: state.notes_actions,
        stations: state.stations
    }
};


export default connect(mapStateToProps)(StationDetail);


// WEBPACK FOOTER //
// ./src/containers/site-visits/stationDetail/StationDetail.js